import React, { PropsWithChildren } from 'react';
import { cn } from '../../../../utils/styles';
import InstitutionHeader from './Header';
import InstitutionFooter, { FooterItem } from './Footer';
import InstitutionMenuContextProvider from '../../../context/institutionMenu';

interface LayoutProps extends PropsWithChildren {
  childrenCentered?: boolean;
  footerHidden?: boolean;
  footerItems?: FooterItem[];
  contentClassName?: string;
}

export default function FinancialInstitutionLayout({
  children,
  childrenCentered,
  footerHidden,
  footerItems,
  contentClassName,
}: LayoutProps) {
  return (
    <InstitutionMenuContextProvider>
      <div className={cn('guidance w-full bg-primary-foreground')} id="financial-institution">
        <InstitutionHeader />

        <div
          className={cn('min-h-[calc(100dvh-64px-58px-48px)] md:min-h-[81vh] pt-16 md:pt-0', contentClassName, {
            'max-w-[1200px] mx-auto px-2': childrenCentered,
          })}
        >
          {children}
        </div>

        {!footerHidden ? <InstitutionFooter items={footerItems || undefined} /> : null}
      </div>
    </InstitutionMenuContextProvider>
  );
}

FinancialInstitutionLayout.defaultProps = {
  childrenCentered: false,
  footerHidden: false,
  footerItems: undefined,
  contentClassName: undefined,
};
